// extracted by mini-css-extract-plugin
export default {"insertClauseModal":"style_insertClauseModal__7dcnv","progressBar":"style_progressBar__3FVmR"};